package com.eladfinish.bible.contest.screens.mikud.ui.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.deselect_all
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.ic_checkbox_blank_outline
import com.eladfinish.bible.contest.ic_checkbox_marked
import com.eladfinish.bible.contest.select_all
import com.eladfinish.bible.contest.show_mikud
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionPlacement
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarIcon
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.MikudToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.persistentListOf

enum class MikudToolbarId {
    SELECT_ALL,
    DESELECT_ALL,
    HELP,
    SHOW_MIKUD,
}

@Composable
internal fun MikudMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<MikudToolbarAction>,
) {
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.Mikud,
            title = ToolbarHeaderComponentConfig.Text(text = title),
            actions = persistentListOf(
                ToolbarActionConfig.IconAction(
                    id = MikudToolbarId.SELECT_ALL,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_checkbox_marked)
                    ),
                    menuText = SharedRes.strings.select_all.desc(),
                    onClick = { toolbarEmitter.emit(action = MikudToolbarAction.SelectAllMaterial) },
                ),
                ToolbarActionConfig.IconAction(
                    id = MikudToolbarId.DESELECT_ALL,
                    icon = ToolbarIcon.PainterIcon(
                        painter = painterResource(imageResource = SharedRes.images.ic_checkbox_blank_outline)
                    ),
                    menuText = SharedRes.strings.deselect_all.desc(),
                    onClick = { toolbarEmitter.emit(action = MikudToolbarAction.DeselectAllMaterial) },
                ),
                ToolbarActionConfig.TextActionRes(
                    id = MikudToolbarId.HELP,
                    stringDesc = SharedRes.strings.help.desc(),
                    onClick = { toolbarEmitter.emit(action = MikudToolbarAction.Help) },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = MikudToolbarId.SHOW_MIKUD,
                    stringDesc = SharedRes.strings.show_mikud.desc(),
                    onClick = { toolbarEmitter.emit(action = MikudToolbarAction.ShowMikud) },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
            )
        )
    )
}
